import { AbstractControl, ValidationErrors } from '@angular/forms';

export function emailsMatch(group: AbstractControl): ValidationErrors | null {
  const email = group.get('email')?.value?.trim() || '';
  const confirm = group.get('confirm')?.value?.trim() || '';
  return email && confirm && email !== confirm ? { emailsDontMatch: true } : null;
}
